import { Box } from '@mui/material';
import AccountMenu from './AccountMenu';
import { useIsMobile } from 'src/Core/hooks/useIsMobile';

interface PageActionsProps {
  children?: React.ReactNode;
}

/**
 * Right-side actions for page headers. Renders page-specific action icons
 * (e.g. download) alongside the global AccountMenu user icon (desktop only).
 */
export default function PageActions({ children }: PageActionsProps) {
  const isMobile = useIsMobile();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      {children}
      {!isMobile && <AccountMenu />}
    </Box>
  );
}
